import {cn} from "@/lib/utils";
import dayjs from "dayjs";
import {TrendsBarChart} from "./bar-chart";
import React from "react";
import {Spin} from "antd";

const UpIcon = () => (
  <div className="border-[3px] border-[#004AAB] rounded w-fit flex justify-center items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={3}
      stroke="#004AAB"
      className="w-8 h-4 hover:-translate-y-1 transition duration-100 ease-in-out"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75"
      />
    </svg>
  </div>
)

const DownIcon = () => (
  <div className="border-[3px] border-[#F84F07] rounded w-fit flex justify-center items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={3}
      stroke="#F84F07"
      className="w-8 h-4 hover:translate-y-1 transition duration-100 ease-in-out"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 13.5L12 21m0 0l-7.5-7.5M12 21V3"
      />
    </svg>
  </div>
)

interface Props {
  dir: "up" | "down";
  slug: string;
  data: any;
  lastCrawl?: string;
  isBrand?: boolean;
}

export const SubTrends: React.FC<Props> = ({
  dir = "up",
  slug,
  data,
  lastCrawl = dayjs().toISOString(),
  isBrand = false,
}) => {
  const isUp = dir == "up";

  return (
    <>
      <div className="flex">
        {isUp ? <UpIcon /> : <DownIcon />}

        <h1
          className={cn(
            "text-xl font-bold text-left w-fit py-3 px-5",
            dir == "up" ? "text-[#004AAB]" : "text-[#F84F07]"
          )}
        >
          {isBrand ? "Merek" : "Topik umum"}&nbsp;sektor {slug.toLowerCase()}
          &nbsp;yang mengalami&nbsp;{isUp ? "kenaikan" : "penurunan"}.
        </h1>
      </div>

      <>
        <p className="text-black text-xs my-2">
          Data ini diambil dari Google Trends, dan menunjukkan persentase&nbsp;
          {isUp ? "kenaikan" : "penurunan"}. dibandingkan periode yang sama pada
          tahun sebelumnya.
        </p>
        <Spin tip="Loading" size="large" spinning={!!!data}>
          <TrendsBarChart direction={dir} data={data} isBrand={isBrand} />
        </Spin>
      </>

      <p className="text-gray-400 text-[0.75rem]">
        Membandingkan :{" "}
        {`${dayjs()
          .month(0)
          .date(1)
          .subtract(1, "year")
          .toISOString()
          .slice(0, 10)} hingga ${dayjs()
            .subtract(1, "year")
            .toISOString()
            .slice(0, 10)}`}{" "}
        dengan{" "}
        {`${dayjs()
          .month(0)
          .date(1)
          .toISOString()
          .slice(0, 10)} hingga ${dayjs().toISOString().slice(0, 10)}`}{" "}
      </p>
      <p className="text-gray-400 text-[0.75rem]">
        Data terakhir diambil: {lastCrawl && lastCrawl.slice(0, 10)}
      </p>
    </>
  );
}
